import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  IconButton,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const styles = {
  headerTxt: {
    fontWeight: "540",
    letterSpacing: "0.6px",
    fontSize: 20,
  },
  closeBtn: {
    position: "absolute",
    right: 12,
    top: 12,
    color: "rgba(0, 0, 0, 0.54)",
  },
  message: {
    color: "rgba(0, 0, 0, 0.87)",
  },
  actionBtn: {
    ml: 2,
    mr: 1,
  },
  buttonLayout: {
    my: 0.5,
  },
  buttonTxt: {
    fontWeight: "510",
    letterSpacing: "0.5px",
    fontSize: 14,
  },
};

export default function PublishDialog({ show, close, onPublish }: any) {
  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={show}
      onClose={close}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title" sx={styles.headerTxt}>
        Publish To Open Orders?
      </DialogTitle>
      <Divider />
      <IconButton aria-label="close" onClick={close} sx={styles.closeBtn}>
        <CloseIcon />
      </IconButton>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" sx={styles.message}>
          Are you sure you want to publish to all open orders using this form?
          Any responses input may be lost if any form elements are changed,
          deleted, or flagged as “inactive”.
        </DialogContentText>
      </DialogContent>
      <Divider />
      <DialogActions sx={styles.buttonLayout}>
        <Button variant="outlined" onClick={close}>
          <Typography sx={styles.buttonTxt}>Cancel</Typography>
        </Button>
        <Button sx={styles.actionBtn} variant="contained" onClick={onPublish}>
          <Typography sx={styles.buttonTxt}>Publish to Open Orders</Typography>
        </Button>
      </DialogActions>
    </Dialog>
  );
}
